<template>
    <div class="row align-items-center u-mb-small">
        <div class="col-sm-4 col-sm-offset-2">
            <div class="c-field">
                <input type="text"
                    :value="name"
                    @input="emit('update:name', $event.target.value)"
                    @keyup="checkAttributeState"
                    class="c-input" 
                    data-test="attribute_name"
                    placeholder="Attribute name"
                />
                <error-handler v-if="v.name.$error" :errors="v.$errors" attribute="name"></error-handler>
            </div>
        </div>


        <div class="col-sm-1 u-text-center">
            <i class="u-block fa fa-fw fa-arrow-right fa-lg"></i>
        </div>


        <div class="col-sm-4">
            <div class="c-field">
                <input type="text"
                    :value="value"
                    @input="emit('update:value', $event.target.value)"
                    @keyup="checkAttributeState"
                    class="c-input"
                    data-test="attribute_value"
                    placeholder="Attribute value"
                />
                <error-handler v-if="v.value.$error" :errors="v.$errors" attribute="value"></error-handler>
            </div>
        </div>


        <div class="col-sm-1">
            <a @click.prevent="emit('remove')" href="#" class="u-color-danger">
                <vx-icon name="times" :size="30" alt="Remove custom attribute" data-test="remove-custom-attribute"></vx-icon>
            </a>
        </div>

    </div>
    <!-- eo .row -->
</template>

<script setup>
import { computed } from 'vue';
import { VxIcon } from '@voxie/frontend-components-v3';
import useVuelidate from '@vuelidate/core'
import { required, maxLength, helpers } from '@vuelidate/validators'
import ErrorHandler from '~/components/general/Vuelidate/ErrorHandler.vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    value: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['invalid', 'update:name', 'update:value', 'remove']);

const rules = computed(() => ({
    name: {
        required,
        maxLength: maxLength(80),
        regex: helpers.withMessage(
            "You can use only alphanumeric letters, space and the following symbols: _-!#$%&'()*+,./:?@|",
            helpers.regex(/^[a-zA-Z0-9_\- !#$%&'()*+,./:?@|]*$/)
        )
    },
    value: {
        required,
        maxLength: maxLength(350),
        regex: helpers.withMessage(
            "You can use only alphanumeric letters, space and the following symbols: :.@#$%&'*(),!?-\\=_+[]/",
            helpers.regex(/^[a-zA-Z0-9:.@#$%&'*(),!?\-\\=_+[\] /]*$/)
        )
    }
}));

const state = computed(() => ({
    name: props.name,
    value: props.value
}))
const v = useVuelidate(rules, state, { $autoDirty: true });

const checkAttributeState = () => {
    emit('invalid', v.value.attribute?.key.$error || v.value.attribute?.value.$error);
};
</script>
